import { apiRequest } from '../../services/apiClient';
import { CEO_PROFILE, COMPANY_HISTORY, COMPANY_INTRO, CeoProfile, DESIGN_SERVICES, DesignService, ListGroup } from './companyContent';

// 회사소개 > 연혁 페이지 내용. 관리자 콘솔(/admin/company-history)에서 수정한다
export interface CompanyHistoryContent {
  intro: { badges: string[]; text: string[] };
  history: ListGroup[];
  ceo: CeoProfile;
  services: DesignService[];
}

// 관리자가 아직 저장하지 않았을 때 보여줄 기본 문구 (companyContent.ts)
export const DEFAULT_COMPANY_HISTORY: CompanyHistoryContent = {
  intro: COMPANY_INTRO,
  history: COMPANY_HISTORY,
  ceo: CEO_PROFILE,
  services: DESIGN_SERVICES,
};

export function fetchCompanyHistory(): Promise<{ content: CompanyHistoryContent | null }> {
  return apiRequest<{ content: CompanyHistoryContent | null }>('/api/company-history');
}
